
export enum DriverDecisionSupportType {
    DigiDL = 0,
    KLine = 1
}
